import React from "react";
import {Chip, Paper, Stack, TextField, Typography} from "@mui/material";

export default function FooterSection(
    {
        category,
        templateType,
        footer,
        setFooter,
        remainingFooter
    }
) {
    // ✅ Render condicional correcto
    if (category === "authentication" || templateType === "carousel") return null;
    const FOOTER_LIMIT = 60;

    return (
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
            <Stack gap={1}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <Typography variant="h6">Footer</Typography>
                    <Chip label="Optional" size="small"/>
                </Stack>

                <TextField
                    placeholder="Texto del pie"
                    value={footer}
                    onChange={(e) => setFooter(e.target.value.slice(0, FOOTER_LIMIT))}
                    helperText={`${remainingFooter} restantes`}
                    fullWidth
                    size="small"
                />
            </Stack>
        </Paper>
    );
}
